import React, { useLayoutEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';

import rainbowImg from '../../styles/theme/childrenDay/rainbow.svg';
import styles from './ChildrenDayRainbow.styl';

const cx = classNames.bind(styles);

const SIDEBAR_SELECTOR = '[data-theme-sidebar]';

function rectsOverlap(a, b) {
  return !(a.right <= b.left || a.left >= b.right || a.bottom <= b.top || a.top >= b.bottom);
}

export default function ChildrenDayRainbow() {
  const rainbowRef = useRef(null);
  const [isHidden, setIsHidden] = useState(false);
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const rainbow = rainbowRef.current;

    if (!rainbow) {
      return undefined;
    }

    const observedSidebars = new WeakSet();

    const observeSidebars = () => {
      document.querySelectorAll(SIDEBAR_SELECTOR).forEach(sidebar => {
        if (!observedSidebars.has(sidebar)) {
          resizeObserver.observe(sidebar);
          observedSidebars.add(sidebar);
        }
      });
    };

    const checkOverlap = () => {
      observeSidebars();

      const rainbowRect = rainbow.getBoundingClientRect();

      if (!rainbowRect.width || !rainbowRect.height) {
        return;
      }

      const sidebars = document.querySelectorAll(SIDEBAR_SELECTOR);
      let overlaps = false;

      sidebars.forEach(sidebar => {
        const sidebarRect = sidebar.getBoundingClientRect();

        if (sidebarRect.width && sidebarRect.height && rectsOverlap(rainbowRect, sidebarRect)) {
          overlaps = true;
        }
      });

      setIsHidden(overlaps);
    };

    const resizeObserver = new ResizeObserver(checkOverlap);

    resizeObserver.observe(rainbow);
    observeSidebars();
    checkOverlap();

    window.addEventListener('scroll', checkOverlap, { passive: true });
    window.addEventListener('resize', checkOverlap, { passive: true });

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('scroll', checkOverlap);
      window.removeEventListener('resize', checkOverlap);
    };
  }, [pathname]);

  return (
    <img
      ref={rainbowRef}
      className={cx('ChildrenDayRainbow', { ChildrenDayRainbow_hidden: isHidden })}
      src={rainbowImg}
      alt=""
      aria-hidden="true"
    />
  );
}
